import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Evaluations } from 'src/app/_models';

@Injectable({
  providedIn: 'root'
})
export class EvaluationsService {
  private url = environment.apiUrl;
  constructor(private http: HttpClient) {}
  GetEvaluationStudents(classId: number, sectionId: number) {
    return this.http.get(`${this.url}Evaluation/GetEvaluationStudents?classId=${classId}&sectionId=${sectionId}`);
  }
  GetEvaluations(classId: number, sectionId: number, sectionSubjectId: number, date: string) {
    return this.http.get(
      `${this.url}Evaluation/GetEvaluations?classId=${classId}&sectionId=${sectionId}&sectionSubjectId=${sectionSubjectId}&data=${date}`
    );
  }
  GetStudentEvaluations(studentId: string) {
    return this.http.get(`${this.url}Evaluation/GetStudentEvaluations/${studentId}`);
  }
  GetEvaluationDetails(evaluationId: number) {
    return this.http.get(`${this.url}Evaluation/GetEvaluationDetails/${evaluationId}`);
  }
  AddEvaluation(evaluations: Evaluations) {
    return this.http.post(`${this.url}Evaluation/AddEvaluation`, evaluations);
  }
}
